/**
 * Akış klavye gezinmesi (WAI-ARIA APG feed deseni, 12.3 #9): Page Down/Up sonraki/önceki karta,
 * Ctrl+End akıştan sonraki, Ctrl+Home akıştan önceki odaklanabilir öğeye. Kartlar sekme sırasına
 * eklenmez (`tabIndex=-1`); karta içindeki bir düğmeden ya da önceki karttan gelinir.
 */
export type FeedKeyMove =
  | { kind: 'article'; index: number }
  | { kind: 'exit'; after: boolean }
  | null;

export function feedKeyMove(
  key: string,
  ctrl: boolean,
  current: number,
  count: number,
): FeedKeyMove {
  if (current < 0 || !count) return null;
  if (ctrl && key === 'End') return { kind: 'exit', after: true };
  if (ctrl && key === 'Home') return { kind: 'exit', after: false };
  if (ctrl) return null;
  if (key === 'PageDown')
    return current < count - 1 ? { kind: 'article', index: current + 1 } : null;
  if (key === 'PageUp') return current > 0 ? { kind: 'article', index: current - 1 } : null;
  return null;
}

const TABBABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Akışın dışındaki ilk (sonraki) ya da son (önceki) odaklanabilir öğe. */
export function focusOutside(feed: HTMLElement, after: boolean): HTMLElement | null {
  const all = Array.from(document.querySelectorAll<HTMLElement>(TABBABLE)).filter(
    node => !feed.contains(node) && node.offsetParent !== null,
  );
  const position = (node: HTMLElement) =>
    // eslint-disable-next-line no-bitwise -- DOM konum bayrağı
    feed.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING;
  return after ? all.find(position) || null : all.filter(node => !position(node)).pop() || null;
}
